import { render } from "./EduAreasView.vue?vue&type=template&id=4291ffc0&scoped=true"
import script from "./EduAreasView.vue?vue&type=script&lang=js"
export * from "./EduAreasView.vue?vue&type=script&lang=js"

import "./EduAreasView.vue?vue&type=style&index=0&id=4291ffc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4291ffc0"]])

export default __exports__